/**
 * Obsługa modala z karuzelą zdjęć na karcie produktu
 * @type module
 */
app.service('productMultimedia',function(loading, productCardConfig, slider360, modal, console, productCompare, productClipboard, front) {
	var $self=false;
	var $modal=false;
	var $liList, $liPreview, $zoom;
	var options={};
	var activeType=false;
	var activeElement=false;
	var zoomEnabled=false;
	var activeListElement=0;
	var isLoad=false;
	var videoPlayers = [];

	function setElements(){
		$self=$('#multimedia-modal');
		$liList=$('#multimedia-lists li', $self);
		$liPreview=$('#multimedia-preview li', $self);
		$zoom=$('#multimedia-zoom', $self);
	}
	function setEvents(){
		productClipboard.checkClipboard();
		$('.js-photo-types', $self).click(function(){
			toggleType('photo');
		});
		$('.js-video-types', $self).click(function(){
			toggleType('video');
		});
		$('.js-presentation-types', $self).click(function(){
			toggleType('presentation');
		});

		$('.js-multimedia-photo', $self).click(function(){
			showMedia(activeType, $liList.filter(':visible').index($(this).parent()));
		});
		$('.js-multimedia-video', $self).click(function(){
			showMedia(activeType, $liList.filter(':visible').index($(this).parent()));
		});
		$('.js-multimedia-presentation', $self).click(function(){
			showMedia(activeType, $liList.filter(':visible').index($(this).parent()));
		});

		$('.js-multimedia-preview-next', $self).click(function(){
			nextPreview();
		});
		$('.js-multimedia-preview-prev', $self).click(function(){
			prevPreview();
		});

		$('.js-multimedia-list-next', $self).click(function(){
			nextList();
		});
		$('.js-multimedia-list-prev', $self).click(function(){
			prevList();
		});

		$zoom.click(function(){
			zoom();
		});

		$('.js-multimedia-zoom', $self).click(function(){
			zoom($(this).data('zoom'), $(this).find('img').attr('src'));
		});

	}
	function toggleType(type){
		if(type==activeType){
			changeType(false);
		}else{
			showMedia(type, 0);
		}
	}
	function zoom(src, bg){
		if(zoomEnabled){
			zoomEnabled=false;
			$zoom.trigger('zoom.destroy');
			$self.removeClass('show-zoom');
		}else{
			if(src){
				zoomEnabled=true;
				$self.addClass('show-zoom');
				$zoom.empty().append('<img alt="" class="small-photo" src="'+bg+'"/>').zoom({
					url: src,
					callback:function(){
						$zoom.trigger('mouseover');
					}
				});
			}
		}
	}
	function carouselListEnabled(){
		$self.addClass('list-carousel list-carousel-first').removeClass('list-no-carousel list-carousel-last');
		$self.addClass('shift-0');
		$self.removeClass('shift-'+activeListElement);
		activeListElement=0;
	}
	function carouselListArrow(){
		var count=$liList.filter(':visible').length;
		if(activeListElement===0){
			$self.addClass('list-carousel-first');
		}else{
			$self.removeClass('list-carousel-first');
		}
		if(activeListElement+7===count){
			$self.addClass('list-carousel-last');
		}else{
			$self.removeClass('list-carousel-last');
		}
	}
	function carouselListDisabled(){
		$self.addClass('list-no-carousel').removeClass('list-carousel');
	}
	function carouselPreviewDisabled(){
		$self.addClass('preview-no-carousel').removeClass('preview-carousel');
		$liPreview.removeClass('preview-left preview-active preview-right');
	}
	function carouselPreviewEnabled(){
		$self.addClass('preview-carousel').removeClass('preview-no-carousel');
		rebuildPreview(activeType, 0);
	}
	function setCarousel(){
		var count=$liList.filter(':visible').length;
		$self.removeClass('preview-carousel-first preview-carousel-last list-carousel-first list-carousel-last');
		if(count==1){
			carouselPreviewDisabled();
		}else{
			carouselPreviewEnabled();
		}
		if(count<8){
			carouselListDisabled();
		}else{
			carouselListEnabled();
		}
	}
	function prevList(){
		if(activeListElement>0){
			$self.addClass('shift-'+(activeListElement-1));
			$self.removeClass('shift-'+activeListElement);
			activeListElement--;
			carouselListArrow();
		}
	}
	function nextList(){
		var count=$liList.filter(':visible').length;
		if(activeListElement+7<count){
			$self.addClass('shift-'+(activeListElement+1));
			$self.removeClass('shift-'+activeListElement);
			activeListElement++;
			carouselListArrow();
		}
	}
	function nextPreview(){
		var $li=(activeType)?$liPreview.filter('.'+activeType):$liPreview;
		var length=$li.length;
		if(activeElement+1<length){
			showMedia(activeType, activeElement+1);
		}
	}
	function prevPreview(){
		if(activeElement>0){
			showMedia(activeType, activeElement-1);
		}
	}
	function rebuildPreview(type, index){
		if(zoomEnabled){
			zoom();
		}
		activeType=type;
		activeElement=index;
		var $li=(type)?$liPreview.filter('.'+type):$liPreview;

		if($li.length-1==index){
			$self.addClass('preview-carousel-last');
		}else{
			$self.removeClass('preview-carousel-last');
		}

		if(index===0){
			$self.addClass('preview-carousel-first');
		}else{
			$self.removeClass('preview-carousel-first');
		}
		$li.each(function(i,element){
			var $element=$(element);
			if(i<index){
				$element.addClass('preview-left');
			}else{
				$element.removeClass('preview-left');
			}

			if(i==index){
				$element.addClass('preview-active');
			}else{
				$element.removeClass('preview-active');
			}

			if(i>index){
				$element.addClass('preview-right');
			}else{
				$element.removeClass('preview-right');
			}
		});
	}
	function getLi(){
		return (activeType)?$liPreview.filter('.'+activeType):$liPreview;
	}
	function setVideo($element) {
		var iframe=$element.find('iframe');
		iframe.attr('src', $element.data('src'));

		if (!$element.data('loaded')) {

			if(!iframe.data('height')){
				var iframeHeight=parseInt(iframe.attr('height'));
				$element.css("padding-top",($element.height()-iframeHeight)/2);
				iframe.data('height',iframeHeight);
			}

			videoPlayers.push(iframe[0]);

			$element.data('loaded', true);
		}
	}
	function setPresentation($element){
		slider360.init();
	}
	function setPhoto($element){
		//obecnie pusty
	}
	function stopVideos(){
		$(videoPlayers).each(function() {
			var source = $(this).attr('src');
			$(this).attr('src', '');
			$(this).data('src', source);
		});
	}
	function showMedia(type, index){
		if(type!=activeType){
			changeType(type);
		}
		rebuildPreview(type, index);
		var $element=getLi().eq(index);
		stopVideos();
		if($element.hasClass('video')){
			setVideo($element);
		}else if($element.hasClass('presentation')){
			setPresentation($element);
		}else if($element.hasClass('photo')){
			setPhoto($element);
		}
	}

	function changeType(type){
		if(type==activeType){
			activeType=false;
		}else{
			activeType=type;
		}
		$self.removeClass('type-photo type-video type-presentation');
		if(activeType){
			$self.addClass('type-'+activeType);
		}
		setCarousel();
	}
	function open(){
		$modal.open();
		startView();
	}
	function startView(){
		showMedia(options.type, options.index);
	}
	function setKeyboardEvent(){
		$(window).keyup(function(event){
			if(modal.isOpen('multimedia-modal')){
				if(event.keyCode===27){
					if(zoomEnabled){
						zoom();
					}else{
						modal.close();
					}
				}else if(event.keyCode===37){
					prevPreview();
				}else if(event.keyCode===39){
					nextPreview();
				}
				event.preventDefault();
			}
		});
	}
	function loadError(){
		modal.alert('Wystąpił błąd ładowania galerii multimediów. Prosimy spróbować później');
	}
	function loadSuccess(html){
		$modal=modal.generate({
			id:'multimedia-modal',
			content:html,
			closeOnEscape:false,
			callbackOpen:function(){
				setElements();
				setEvents();
				if(front.katalog) {
					productCompare.checkCompared();
				}
				startView();
			},
			callbackClose:function(){
				stopVideos();
			}
		});
		isLoad=true;
		setKeyboardEvent();
	}
	function load(){
		loading.start();
		$.ajax({
			url:'/product-multimedia.ltr',
			data:{
				productId:options.productId
			},
			success:function(html){
				loadSuccess(html);
			},
			error:function(){
				loadError();
			},
			complete:function(){
				loading.stop();
			}
		});
	}
	function show(params){
		options=params;
		if(isLoad===true){
			open();
		}else{
			load();
		}
	}
	return {
		show:show
	};
});
